import React, { useState, useEffect, useContext } from 'react';
import { isEmpty } from 'lodash-es';
import * as PropTypes from 'prop-types';

import { Button } from 'datocms-react-ui';

import Spinner from './components/Spinner';
import ModelView from './components/ModelView';
import { DatoApiFacadeContext, ModelSelection } from '@polestar/content-plugin-core';

Main.propTypes = {
  plugin: PropTypes.object
};

function Main(props) {
  const { plugin } = props;
  const { api } = useContext(DatoApiFacadeContext);

  const [models, setModels] = useState();
  const [selectedModel, setSelectedModel] = useState(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    const fetchModels = async () => {
      // transform for fast access
      const models = await api.getModels();
      setModels(models);
    };
    fetchModels();
  }, []);

  function modelSelected(event) {
    setSelectedModel(event);
  }

  function changeModel() {
    setSelectedModel(null);
  }

  function renderModelSelection() {
    return (
      <div>
        {!selectedModel ? (
          <ModelSelection models={models} onModelSelected={modelSelected} />
        ) : (
          <div>
            <Button onClick={changeModel}>Change selected model</Button>
            <div className="spacer" type="horizontal" style={{ height: '15px' }} />
            <ModelView plugin={plugin} model={selectedModel} />
          </div>
        )}
      </div>
    );
  }

  return <div style={{ marginBottom: '100px' }}>{isEmpty(models) ? <Spinner /> : renderModelSelection()}</div>;
}

export default Main;
